import type { FC } from 'react';
import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from '@alfa-bank/site-dc-form-api/store';

import type { TDcForm } from './models';
import { DcForm } from './dc-form';

export const DcFormWrapper: FC<TDcForm> = props => {
    const store = createStore();

    return (
        <Provider store={store}>
            <DcForm {...props} />
        </Provider>
    );
};
